import {ApiParameterObj} from './ApiParameterObj';

export class ApiConfigurationObj {
authConnection: string;
format: string;
method: string;
params: ApiParameterObj[];
}

